/* eslint-disable react-hooks/exhaustive-deps */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCultivo } from "../../../hooks/useCultivo";
import { useEffect, useState } from "react";

export const ProgramacionFilter = ({
  values,
  handleChange,
  setFieldValue,
  onAddClick,
  onDownloadClick,
  isDownloadLoading,
}) => {
  const { getCultivo } = useCultivo();
  const [cultivoOptions, setCultivoOptions] = useState([]);

  useEffect(() => {
    const getCultivoData = async () => {
      const response = await getCultivo();
      setCultivoOptions(response);
      if (response.length === 1) {
        setFieldValue("id_cultivo", response[0].idcultivo);
      }
    };
    getCultivoData();
  }, []);

  return (
    <form className="row">
      <label className="col-md-4 col-sm-12">
        <label>Cultivo</label>
        <select
          className="form-control"
          value={values.id_cultivo}
          onChange={handleChange}
          name="id_cultivo"
          disabled={cultivoOptions.length === 1}
        >
          <option>Seleccionar...</option>
          {cultivoOptions.map((item) => (
            <option value={item.idcultivo} key={item.idcultivo}>
              {item.cultivo}
            </option>
          ))}
        </select>
      </label>
      <label className="col-md-4 col-sm-12">
        <label>Fecha</label>
        <input
          className="form-control"
          type="date"
          value={values.fecha}
          onChange={handleChange}
          name="fecha"
        />
      </label>
      <div className="col-md-3 col-sm-12 mt-4">
        <button
          className="btn btn-success ms-2"
          type="button"
          onClick={onAddClick}
        >
          + Nuevo
        </button>
        <button
          className="btn btn-outline-success ms-2"
          type="button"
          onClick={onDownloadClick}
          disabled={isDownloadLoading}
        >
          {!isDownloadLoading ? (
            <FontAwesomeIcon icon="fas fa-file-excel" />
          ) : (
            <FontAwesomeIcon icon="fas fa-spinner" spin />
          )}
        </button>
      </div>
    </form>
  );
};
